import axios from 'axios';
import { useQuery } from 'react-query';
import { API_URL, getCachedSessionId } from '../../services/common';

const fetchResource = async (resourceId, projectId) => {
  const response = await axios.get(
    `${API_URL}/v1/project/${projectId}/provider/hosting/resource/${resourceId}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};

export const useResource = (resourceId, projectId) => {
  return useQuery(['resource', resourceId], () => fetchResource(resourceId, projectId), {
    enabled: Boolean(resourceId)
  });
};
